import styled from "styled-components";
import { Colors } from "../../../../constants/Colors";


export const SearchPlateWrapper = styled.div`
    background-color: ${Colors.bgLight};
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 2.5rem;
    width: 23rem;
    border: 2px solid black;
    border-radius: 0.5rem;
    box-shadow: 0.25rem 0.25rem 0.1rem rgba(0,0,0,0.25);

    .MuiInputBase-input {
        font-size: 2rem;
        height: 100%;
        padding: 0.5rem 1rem;
    }
    fieldset {
        border: none;
    }
`;

export const SearchButton = styled.button`
    width: 12rem;
    height: 100%;
    border: none;
    background-color: ${Colors.primary[100]};
    color: ${Colors.commons.white};
    font-size: 1.5rem;
    cursor: pointer;
`;

